import { render, staticRenderFns } from "./SlotsHead.vue?vue&type=template&id=003890f3&scoped=true"
import script from "./SlotsHead.vue?vue&type=script&lang=js"
export * from "./SlotsHead.vue?vue&type=script&lang=js"
import style0 from "./SlotsHead.vue?vue&type=style&index=0&id=003890f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003890f3",
  null
  
)

export default component.exports